import React from 'react';
import { useNavigate } from 'react-router-dom';

import { List } from '@common/typescript/objects/List';

import { rest } from '@app/components/Api';
import MiddleText from '@app/components/UI/MiddleText/MiddleText';
import SliderDotsArrows from '@app/components/UI/Slider/SliderDotsArrows';
import { useIsMobile } from '@app/hooks/useIsMobile';
import { TestimonialsWithVetData } from '@app/objects/Testimonials';

const SliderAreaVet = (props) => {
	const { vet } = props;
	const [testimonials, setTestimonials] = React.useState<Array<TestimonialsWithVetData>>([]);
	const navCollapse = useIsMobile();
	const [paddingTop, setPaddingTop] = React.useState(0);

	const navigate = useNavigate();

	const openFilteredTestimonial = () => {
		navigate('/veterinarian-testimonials', {
			state: {
				vetId: testimonials[0].user.id,
				state: '',
				name: `Dr. ${testimonials[0].user.firstName} ${testimonials[0].user.lastName}`,
				navCollapse,
			},
		});
	};

	React.useEffect(() => {
		rest.get<List<TestimonialsWithVetData>>(`v1/testimonials/?veterinarianId=${vet.id}`).then((res) => setTestimonials(res.list));
	}, []);

	React.useEffect(() => {
		setPaddingTop(document.getElementsByClassName('middle-text__title')[0].clientHeight);
	});

	const handleWindowResize = React.useCallback((event) => {
		setPaddingTop(document.getElementsByClassName('middle-text__title')[0].clientHeight);
	}, []);

	React.useEffect(() => {
		window.addEventListener('resize', handleWindowResize);

		return () => {
			window.removeEventListener('resize', handleWindowResize);
		};
	}, [handleWindowResize]);

	return (
		<div style={{ position: 'relative' }}>
			<MiddleText title={`About Dr. ${vet.firstName} ${vet.lastName}`} text={vet.biography} style={{ paddingTop: `${paddingTop}px` }} />
			{testimonials.length ? (
				<div className="testimonials-slider">
					<SliderDotsArrows sliderItems={testimonials} sliderItemsType="cardTes" />
					<button className="btn btn-primary view-more" onClick={openFilteredTestimonial}>
						View all testimonials
					</button>
				</div>
			) : null}
		</div>
	);
};

export default SliderAreaVet;
